module.exports = __webpack_public_path__ + "static/img/降本增效.00d70461.png";